import { useTranslation } from 'react-i18next';

/**
 * Returns a function that prefixes paths with the current language.
 * Example: lp('/dashboard') → '/en/dashboard'
 */
export function useLocalizedPath() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'en';

  return (path: string) => `/${lang}${path}`;
}
